import { MoonFilled, SunFilled } from '@ant-design/icons'
import type { AntdIconProps } from '@ant-design/icons/lib/components/AntdIcon'

export const AmIcon = (p: AntdIconProps) => <SunFilled style={{ color: 'var(--theme-warning)' }} {...p} />
export const PmIcon = (p: AntdIconProps) => <MoonFilled style={{ color: 'var(--theme-color-1)' }} {...p} />
